import { callApiWithToken } from "../utils/http_common";

const getSubOrgs = () => {
  return callApiWithToken.get(`/organization/fetchSubOrgs`);
};

const createMerchant = (data) => {
  return callApiWithToken.post(`/organization/createMerchant`, data);
};

const createSubMerchant = (data) => {
  return callApiWithToken.post(`/organization/createSubMerchant`, data);
};

const toggleMid = (data) => {
  return callApiWithToken.post(`/organization/toggleMid`, data);
};

const OrganizationService = {
  getSubOrgs,
  createMerchant,
  createSubMerchant,
  toggleMid,
};

export default OrganizationService;
